import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import Button from "@mui/material/Button";
import GoogleIcon from "@mui/icons-material/Google";

const GoogleLoginButton = () => {
  const login = () => {
    window.location.href = `${process.env.REACT_APP_OMS_SERVER_API}/admin/oauth2/authorization/google-admin`;
  };

  return (
    <Button
      variant="contained"
      startIcon={<GoogleIcon />}
      onClick={() => login()}
      fullWidth
      sx={{ height: 35, borderRadius: 1 }}
    >
      구글 로그인
    </Button>
  );
};

export default GoogleLoginButton;
